<script>
  import { createEventDispatcher } from 'svelte';
  import Icon from '../../../common/components/Icon.svelte';

  export let type;
  export let label;

  const dispatch = createEventDispatcher();
  $: symbol = { pros: 'add', cons: 'subtract' }[type];
</script>

<section class="pros-and-cons-item">
  <Icon type="font" glyph={symbol} desktopSize={16} />
  <!-- svelte-ignore a11y-label-has-associated-control -->
  <label>{label}</label>
  <button on:click={() => dispatch('delete')}>
    <Icon type="font" glyph="delete" desktopSize={16} />
  </button>
</section>

<style lang="scss">
  @import '../../../common/styles/colors.new.scss';

  .pros-and-cons-item {
    padding: 12px;
    border: 1px solid $secondary-gray-02;
    border-radius: 8px;
    background-color: $neutral-light-04;
    display: flex;
    align-items: center;
    gap: 8px;

    label {
      flex-grow: 1;
      font-weight: 400;
      font-size: 14px;
      line-height: 16px;
    }
    button {
      border: none;
      background-color: transparent;
      margin: 0;
      padding: 0;
    }
  }
</style>
